'use client';

import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuthStore } from '@/lib/stores/auth';
import { cartQuery } from '@/lib/queries/cart';
import { useQuery } from '@tanstack/react-query';
import { ShoppingCart } from 'lucide-react';

export function CartBadge() {
  const { isAuthenticated, token } = useAuthStore();
  const { i18n } = useTranslation();
  const locale = i18n.language;

  // 与 CartPage 共享 ['cart'] 缓存：任一处加购/删除/清空触发 invalidate 后，
  // 气泡计数与列表实时同步更新（修复气泡不实时刷新）。
  // 注意：必须复用 cartQuery（同 queryKey + 同返回形状），否则 react-query 共享
  // 缓存会写入形状不符的数据，导致另一组件崩溃。
  const { data } = useQuery({
    ...cartQuery,
    enabled: !!isAuthenticated && !!token,
  });
  const count = data?.length ?? 0;

  return (
    <Link to={`/${locale}/cart`} className="relative text-muted-foreground hover:text-foreground transition-colors">
      <ShoppingCart className="w-5 h-5" />
      {count > 0 && (
        <span className="absolute -top-1.5 -right-1.5 bg-brand-600 text-white text-xs font-bold w-4.5 h-4.5 flex items-center justify-center rounded-full min-w-[18px] h-[18px] leading-none">
          {count > 9 ? '9+' : count}
        </span>
      )}
    </Link>
  );
}
